import { crudReducer } from "./dataHelper";

const initialState = () => ({
  event_locations: []
});

export default crudReducer("event_location", initialState);
